module.exports = __webpack_public_path__ + "static/8761adc6994ee361dc1d899af36b98df790b67b906884956f3599d5a60aff384-f6f603943015d1b4db946de864a412f5.jpeg";